import request from '@/utils/request'

export function updateStaticCfg(data) {
  return request({
    url: 'api/v1/static/updateCfg',
    method: 'post',
    data: data,
    timeout: 5000000
  })
}

export function makeZip(data) {
  return request({
    url: 'api/v1/static/makeZip',
    method: 'post',
    data: data
  })
}
export function batchDown(data) {
  return request({
    url: 'api/v1/static/batchDownFile',
    method: 'post',
    data: data,
    timeout: 100000
  })
}
export function updateProxyCfg(data) {
  return request({
    url: 'api/v1/static/updateProxyCfg',
    method: 'post',
    data: data
  })
}

export function getProxyCfg(data) {
  return request({
    url: 'api/v1/static/getProxyCfg',
    method: 'get',
    params: data
  })
}
export function makeStaticJson(data) {
  return request({
    url: 'api/v1/static/makeJson',
    method: 'post',
    data: data,
    timeout: 50000000
  })
}

export function getStaticList(data) {
  return request({
    url: 'api/v1/static/getCfg',
    method: 'post',
    data: data
  })
}

export function delStaticcfg(data) {
  return request({
    url: 'api/v1/static/delCfg',
    method: 'delete',
    data: data
  })
}

export function copyStaticcfg(data) {
  return request({
    url: 'api/v1/static/copyCfg',
    method: 'post',
    data: data
  })
}

export function uploadJson(data) {
  return request({
    url: 'api/v1/static/uploadJson',
    method: 'post',
    data: data,
    timeout: 5000
  })
}

export function ossSyncS3(data) {
  return request({
    url: 'api/v1/static/ossSyncS3',
    method: 'post',
    data: data,
    timeout: 100000
  })
}

export function refreshPath(data) {
  return request({
    url: 'api/v1/static/refreshPath',
    method: 'post',
    data: data
  })
}

export function pushObjectCache(data) {
  return request({
    url: 'api/v1/static/pushObjectCache',
    method: 'post',
    data: data
  })
}

